import { CircularProgress } from '@material-ui/core';
import React from 'react';

import { ModelPrimaryButton } from '~/src/dash/components/model-primary-button';

export interface IButtonProps {
  style?: { [key: string]: string };
  text: string;
  onClick: () => void;
  active: boolean;
  disabled?: boolean;
}

export function ButtonView({ active, disabled, onClick, text, style }: IButtonProps) {
  return (
    <ModelPrimaryButton
      style={style}
      variant='contained'
      onClick={onClick}
      disabled={active || disabled}
    >
      {text}
      {active && (
        <>
          &nbsp;
          <CircularProgress
            size={12}
            style={{
              color: 'white',
            }}
          />
        </>
      )}
    </ModelPrimaryButton>
  );
}
